import { GlobalRouterPath } from "./globalRoute";

export function getAppV2Route(relativePath: string) {
  if (relativePath.startsWith("/")) {
    return `${GlobalRouterPath.APP_V2}${relativePath}`;
  }
  return `${GlobalRouterPath.APP_V2}/${relativePath}`;
}
